﻿export const getFormRoute = (route: string, id: string): string => {
    return route.replace(':id', id);
}

export const getRegistrationFormRoute = (route: string, registrationId: string) => {
    return route.replace(':registrationId', registrationId);
}